import { Formik, FormikConfig, FormikValues } from "formik";

export type FormProps<T> = Pick<
  FormikConfig<T>,
  "initialValues" | "validationSchema" | "onSubmit" | "component"
> & {
  validateOnMount?: boolean;
};

export const Form = <T extends FormikValues>({
  initialValues,
  validationSchema,
  onSubmit,
  component,
  validateOnMount = true
}: FormProps<T>) => {
  return (
    <Formik<T>
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      component={component}
      validateOnMount={validateOnMount}
    />
  );
};
